import type { UUID } from '@aline/common';
import * as Sentry from '@sentry/react';
import { Apollo } from 'src/gql/generated';

/**
 * Follows changes made to the open playbook from outside this page: AI
 * suggestions landing one op at a time while the chat drawer's agent writes
 * them, and decisions made from another tab or by a teammate.
 *
 * Each event carries the whole playbook, selected as the same fragment the
 * review mutations return, so Apollo normalizes it over the detail query's
 * entities on arrival. There is nothing to merge here: added rows appear,
 * removed rows drop out of their category's list, and moves land on their new
 * rank. A missed event costs nothing, since the next one carries the full tree.
 */
export function usePlaybookLiveUpdates({ playbookId }: { playbookId: UUID | null }): void {
  Apollo.useOnPlaybookUpdatedSubscription({
    ignoreResults: true,
    onError: error => {
      Sentry.captureException(error, { extra: { subscription: 'PlaybookUpdated' } });
    },
    shouldResubscribe: true,
    skip: !playbookId,
    variables: { playbookId: playbookId ?? '' },
  });
}
